(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }
  const source = root.document.querySelector('script[data-sw-shopping-il-search-offers]');
  if (!source) return;
  let index;
  try { index = api.createOfferIndex(JSON.parse(source.textContent)); } catch (_) { return; }
  root.SwShoppingILSearch = Object.freeze({
    render: (element, result, handle) => api.render(element, result, handle, index)
  });
})(typeof window === 'object' ? window : globalThis, function () {
  'use strict';
  function minorUnits(value) {
    if (typeof value === 'number') return Number.isSafeInteger(value) && value >= 0 ? value : null;
    if (typeof value !== 'string' || !/^(?:0|[1-9]\d*)(?:\.\d{2})?$/.test(value)) return null;
    const amount = Number(value.replace('.', ''));
    return Number.isSafeInteger(amount) ? amount : null;
  }
  function productId(value) {
    const id = String(value == null ? '' : value).replace(/^gid:\/\/shopify\/Product\//, '');
    return /^\d+$/.test(id) ? id : '';
  }
  function productHandle(value) {
    if (typeof value !== 'string') return '';
    const clean = value.split(/[?#]/, 1)[0].split('/').filter(Boolean).pop() || '';
    try { return decodeURIComponent(clean).normalize('NFC'); } catch (_) { return ''; }
  }
  function createOfferIndex(config) {
    const byId = new Map(), byHandle = new Map();
    if (!config || config.version !== 1 || !Array.isArray(config.offers)) return {byId, byHandle};
    for (const offer of config.offers) {
      const id = productId(offer && offer.id), handle = productHandle(offer && offer.handle);
      if (!id || !handle || !Number.isInteger(offer.percent) || offer.percent <= 0 || offer.percent >= 100 ||
          !Number.isSafeInteger(offer.nativePrice) || offer.nativePrice < 0 || typeof offer.html !== 'string' ||
          !offer.html.includes('sw-shopping-il-price') || byId.has(id) || byHandle.has(handle)) continue;
      const approved = Object.freeze({id, handle, percent: offer.percent, nativePrice: offer.nativePrice, html: offer.html});
      byId.set(id, approved); byHandle.set(handle, approved);
    }
    return {byId, byHandle};
  }
  function chooseOffer(result, handle, index) {
    if (!result || !index) return null;
    const id = productId(result.id), key = productHandle(handle || result.handle || result.url);
    const byId = id && index.byId.get(id), byHandle = key && index.byHandle.get(key);
    if (byId && key && byId.handle !== key || byId && byHandle && byId !== byHandle) return null;
    const offer = byId || byHandle;
    if (!offer) return null;
    const min = minorUnits(result.price_min), max = minorUnits(result.price_max);
    return min !== null && max !== null && min === max && min === offer.nativePrice ? offer : null;
  }
  function render(element, result, handle, index) {
    const offer = chooseOffer(result, handle, index);
    if (!element || !offer || !element.classList || !element.dataset) return false;
    element.classList.remove('limoniapps-discountninja-productprice');
    element.classList.add('sw-shopping-il-search-price');
    element.dataset.swShoppingIlSearch = offer.id;
    element.innerHTML = offer.html;
    return true;
  }
  return Object.freeze({minorUnits, productId, productHandle, createOfferIndex, chooseOffer, render});
});
